import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { references } from '../data/recognition';
export function References() {
  return <div data-id="element-223" data-mp="quuqj7fnbgni">
      <ul className="grid gap-4 sm:grid-cols-2" data-id="element-224" data-mp="qx7478edf4ur">
        {references.map(r => <li key={r.url} data-id="element-225" data-mp="14u2su973v4vx">
            <a href={r.url} target="_blank" rel="noreferrer" className="group flex h-full items-start justify-between gap-4 rounded-xl border border-rule bg-cream-deep p-5 transition-colors duration-150 hover:border-forest focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-forest" data-id="element-226" data-mp="10taifcmhyty2">
              <div className="min-w-0" data-id="element-227" data-mp="h5b5pw8dhcq0">
                <p className="text-sm font-semibold text-wheat-dark" data-id="element-228" data-mp="h48f7peypcam">{r.source}</p>
                <p className="mt-1 font-serif text-lg text-forest" data-id="element-229" data-mp="3pkl7f38cofx9">{r.title}</p>
                <p className="mt-2 truncate text-sm text-charcoal-muted" data-id="element-230" data-mp="3ljhsciy4mnx3">{r.display}</p>
              </div>
              <ArrowUpRightIcon className="h-5 w-5 shrink-0 text-charcoal-muted transition-colors duration-150 group-hover:text-forest" aria-hidden="true" data-id="element-231" data-mp="2pwyigin9l0f4" />
            </a>
          </li>)}
      </ul>
    </div>;
}